<div class="d-flex" id="wrapper">

  <admin-sidebar id="admin-sidebar"></admin-sidebar>

  <div id="page-content-wrapper">

    <admin-navigation></admin-navigation>

    <div class="container-fluid">
      <div class="mt-5 mt-md-5 mb-5 mb-md-5">
        <h3 class="d-inline-block font-weight-bold page-title">Series & Modules</h3>
        <button type="button" class="btn btn-primary pull-right add-button" data-toggle="modal" data-target="#addSeries" (click)="resetForm()">Add Series</button>
      </div>
      <div class="row">
        <div class="col-md-12 table-responsive">
          <table class="table table-borderless">
            <colgroup>
              <col width="5%">
              <col width="25%">
              <col width="30%">
              <col width="20%">
              <col width="20%">
            </colgroup>
            <thead>
              <tr>
                <th class="text-center"></th>
                <th class="text-left">Series</th>
                <th class="text-center">Created</th>
                <th class="text-center">Status</th>
                <th class="text-right"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of series" [id]="data.id">
                <td class="text-center align-middle">{{ data.sequence }}</td>
                <td class="text-left align-middle">{{ data.title }}</td>
                <td class="text-center align-middle">{{ data.created * 1000 | date: 'MMMM d, yyyy' : '+1200' }}</td>
                <td
                  class="text-center align-middle"
                  [ngClass]="{'text-success': data.status == 'Published', 'text-warning': data.status == 'Draft'}"
                >
                  {{ data.status }}
                </td>
                <td class="text-right">
                  <button class="btn btn-sm btn-secondary mr-2 mr-md-2" (click)="showEditSeries(data.id)" style="margin-bottom: 1px;">
                    <i class="fa fa-eye"></i> View
                  </button>
                  <button class="btn btn-sm btn-secondary" data-toggle="modal" data-target="#editSeriesModal" (click)="getSeriesAttributes(data);">
                    <i class="fa fa-pencil-square"></i> Edit
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

    <!-- Add Modal -->
    <div class="modal fade" id="addSeries" tabindex="-1" role="dialog" aria-labelledby="addSeriesLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" id="addSeriesLabel">Add Series</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form [formGroup]="addSeriesForm" (ngSubmit)="onSubmit()">
            <div class="modal-body">
              <div class="md-input">
                <input
                  class="md-form-control"
                  required
                  type="text"
                  formControlName="seriesName"
                  [ngClass]="{'error': (submitted && addSeriesForm.invalid && f.seriesName.invalid) || (f.seriesName.dirty && f.seriesName.invalid)}"
                >
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Series Name</label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" id="close-addSeries-modal" class="btn btn-secondary btn-modal-cancel" data-dismiss="modal">Cancel</button>
              <button type="submit" class="btn btn-primary btn-modal-save">
                Save
                <img src="../../../../../assets/images/loader.gif" *ngIf="loading">
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- End of Add Modal -->

    <!-- Edit Modal -->
    <div class="modal fade" id="editSeriesModal" tabindex="-1" role="dialog" aria-labelledby="editSeriesModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" id="editSeriesModalLabel">Edit Series</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- Error Submit Message -->
          <div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="submitError">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="submitError = !submitError">
              <span aria-hidden="true">&times;</span>
              <span class="sr-only">Close</span>
            </button>
            {{ submitErrorMsg }}
          </div>

          <form [formGroup]="editSeriesForm" (ngSubmit)="updateSeries()">
            <div class="modal-body">
              <div class="md-input">
                <input
                  class="md-form-control"
                  required
                  type="text"
                  formControlName="seriesName"
                  [ngClass]="{'error': (submitted && editSeriesForm.invalid && editF.seriesName.invalid) || (editF.seriesName.dirty && editF.seriesName.invalid)}"
                >
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Series Name</label>
              </div>
              <div class="md-input">
                <input
                  class="md-form-control"
                  required
                  type="number"
                  min="1"
                  formControlName="seriesSequence"
                  [ngClass]="{'error': (submitted && editSeriesForm.invalid && editF.seriesSequence.invalid) || (editF.seriesSequence.dirty && editF.seriesSequence.invalid)}"
                >
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Sequence</label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" id="close-editSeries-modal" class="btn btn-secondary btn-modal-cancel" data-dismiss="modal">Cancel</button>
              <button type="submit" class="btn btn-primary btn-modal-save">
                Save
                <img src="../../../../../assets/images/loader.gif" *ngIf="loading">
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- End of Add Modal -->

  </div>

</div>
